import { IS_REACT_NATIVE_APP } from "@shared/env";

/**
 * TODO: This should be deprecated in favor of user-agent checks, once a bug in react-native-webview is fixed.
 * @see https://github.com/react-native-webview/react-native-webview/issues/2949
 * @see https://github.com/react-native-webview/react-native-webview/blob/master/docs/Reference.md#applicationNameForUserAgent
 */
export const checkForReactNativeAttribute = (): boolean => {
  return !!(
    typeof window !== "undefined" &&
    (window.document.body.getAttribute(IS_REACT_NATIVE_APP) ||
      // Temporarily check for mobile prefix to determine this is a webview for the react native app.
      window.location.href.includes("/mobile/"))
  );
};
